import React from "react";

const Banner = ({ title, subtitle, image }) => {
  return (
    <section
      className="relative w-full h-[60vh] md:h-[75vh] flex items-center justify-center text-center"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl px-6">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">
          {title}
        </h1>

        {subtitle && (
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            {subtitle}
          </p>
        )}

        {/* Golden underline */}
        <div className="mt-6 w-24 h-1 bg-[#E3B66B] mx-auto rounded"></div>
      </div>
    </section>
  );
};

export default Banner;